<div class="flex flex-col justify-between flex-auto items-center">

    <!-- Logo -->
    <app-startup-logo></app-startup-logo>

    <div class="start-up-form-container">

        <!-- Title -->
        <div class="start-up-title"> Please check your Email for the verification code </div>
 
        <!-- Alert -->
        @if (showAlert) {
            <fuse-alert
                class="mt-2"
                [appearance]="'outline'"
                [showIcon]="false"
                [type]="alert.type"
                [@shake]="alert.type === 'error'"
            >
                {{ alert.message }}
            </fuse-alert>
        }

        <!-- Reset password form -->
        <form
            class="mt-3"
            [formGroup]="codeForm"
            #resetPasswordNgForm="ngForm"
        >
            <!-- Code field -->
            <mat-form-field class="mat-form-field-cleaner">
                <mat-label class="font-bold text-md">Place Code Here</mat-label>
                <input 
                    class="input"
                    id="code" 
                    matInput 
                    [formControlName]="'code'" 
                />
                @if (codeForm.get('code').hasError('required')) {
                    <mat-error> Code is required </mat-error>
                }
            </mat-form-field>



            <!-- Actions -->
            <div class="sho-label sho-text-secondary font-bold py-3">
                After hitting Resend Code, please verify that the email did not get caught in your Spam Folder.
            </div>

            <!-- CTA's -->
            <div class="start-up-confirmation-required">

                @if (!codeForm.disabled) {
                    <button
                        class="btn btn-primary mt-4 w-full"
                        [disabled]="codeForm.disabled"
                        (click)="resendCode()"
                    >
                        @if (!codeForm.disabled) {
                            <span class="flex-auto"> Resend Code </span>
                        }
                    </button>

                    <button
                        class="btn btn-secondary mt-4 w-full"
                        [disabled]="false"
                        (click)="verifyCode()"
                    >
                        @if (!codeForm.disabled) {
                            <span class="flex-auto"> Accept </span>
                        }
                    </button>
                }

                @if (codeForm.disabled) {
                    <mat-progress-spinner
                        class="mx-auto mt-7" 
                        [diameter]="24"
                        [mode]="'indeterminate'"
                    ></mat-progress-spinner>
                }
            </div>
        </form>
    </div>

    <!-- Copyright -->
    <app-copyright></app-copyright>
</div>